import { ApiDeleteRequest } from "../api-delete-request";
import { ApiParameters } from "../api-parameters";

export class PaymentMethodDeleteRequest extends ApiDeleteRequest
{
    public constructor(paymentMethodId: string, webapiBasepath: string)
    {
        const parameters = new ApiParameters().addQueryParameter('paymentMethodId', paymentMethodId)
        super(
            'billwerk/deletepaymentmethods',
            parameters,
            null,
            null,
            webapiBasepath
        );
    }
}
